<div
    id="app-toolbar"
    (wheel)="servicesMenu.hide(); supportMenu.hide(); profileMenu.hide()"
    [class.sidebar-expanded]="!isSidebarCollapsed()">
    <span class="utc-clock"><clock-utc></clock-utc></span>

    <div #navBtnServicesContainer class="container">
        <button
            pButton
            type="button"
            class="p-button-secondary p-button-text nav-btn"
            id="nav-btn-services"
            #navBtnServices
            [attr.aria-expanded]="menuServicesOpened()"
            (click)="servicesMenu.toggle($event)">
            <span class="screen-lg">
                {{ 'toolbar.services' | translate }} <i class="fa-regular fa-angle-down"></i>
            </span>
            <span class="screen-sm">YX</span>
        </button>
    </div>

    <div #navBtnSupportContainer class="container">
        <button
            pButton
            type="button"
            class="p-button-secondary p-button-text nav-btn"
            id="nav-btn-support"
            #navBtnSupport
            [attr.aria-expanded]="menuSupportOpened()"
            (click)="supportMenu.toggle($event)">
            <span class="screen-lg">
                {{ 'toolbar.support' | translate }} <i class="fa-regular fa-angle-down" aria-hidden="true"></i>
            </span>
            <span class="screen-sm"><i class="fa-light fa-circle-question"></i></span>
        </button>
    </div>

    <div class="container" id="notifications-container">
        <a
            pButton
            type="button"
            class="p-button-secondary p-button-text nav-btn"
            id="nav-btn-notifications"
            aria-label="Notifications"
            [href]="colonyNotificationsUrl"
            target="_blank">
            <i class="fa-light fa-bell"></i>
        </a>
    </div>

    <div class="container">
        <a
            pButton
            type="button"
            class="p-button-secondary p-button-text nav-btn"
            id="nav-btn-cart"
            aria-label="Cart"
            [href]="colonyOrdersCartUrl"
            target="_blank">
            <i class="fa-light fa-cart-shopping"></i>
        </a>
    </div>

    <div #navBtnSupportContainer class="container">
        <button
            pButton
            type="button"
            class="p-button-secondary p-button-text nav-btn"
            id="nav-btn-user"
            #navBtnUser
            [attr.aria-expanded]="menuProfileOpened()"
            [attr.aria-controls]="'menu-profile-container'"
            (click)="profileMenu.toggle($event)">
            <span style="min-height: 31px; display: flex; justify-content: center; flex-direction: column">
                <p id="nav-current-user-name">
                    {{ userShortName() ?? '-' }}
                </p>
                <p id="nav-current-user-role" style="margin-top: 5px">ADMIN</p>
            </span>
            <span id="user-avatar-container">
                <user-avatar></user-avatar>
            </span>
        </button>
    </div>
</div>

<p-popover
    #servicesMenu
    styleClass="action-item-menu"
    [focusOnShow]="true"
    [appendTo]="navBtnServicesContainer"
    (onShow)="menuServicesOpened.set(true)"
    (onHide)="menuServicesOpened.set(false)">
    <app-menu-services
        #servicesMenu
        (mouseleave)="servicesMenu.hide()"
        (wheel)="servicesMenu.hide()"
        (closePopover)="servicesMenu.hide(); navBtnServices.focus()"></app-menu-services>
</p-popover>

<p-popover
    #supportMenu
    styleClass="action-item-menu"
    [focusOnShow]="true"
    [appendTo]="navBtnSupportContainer"
    (onShow)="menuSupportOpened.set(true)"
    (onHide)="menuSupportOpened.set(false)">
    <app-menu-support
        (mouseleave)="supportMenu.hide()"
        (wheel)="supportMenu.hide()"
        (closePopover)="supportMenu.hide(); navBtnSupport.focus()"></app-menu-support>
</p-popover>

<p-popover
    #profileMenu
    styleClass="action-item-menu"
    [focusOnShow]="true"
    [appendTo]="navBtnSupportContainer"
    (onShow)="menuProfileOpened.set(true)"
    (onHide)="menuProfileOpened.set(false)">
    <app-menu-profile
        (mouseleave)="profileMenu.hide()"
        (wheel)="profileMenu.hide()"
        (closePopover)="profileMenu.hide(); navBtnUser.focus()"></app-menu-profile>
</p-popover>
